import { Icon } from "@tecma/ds";
import { Trans, useTranslation } from "@tecma/i18n";
import {
  ORDERED_FEATURE_KEYS,
  ROOM_FEATURES_INFO,
} from "constants/apartmentFeatures";
import { currencyFormatter } from "utils/currency";
import "./apartment-features.scss";
import { memo } from "react";

export interface Features {
  floor?: number;
  surface?: number;
  bathroom?: boolean;
  bathroom_private?: number;
  bathroom_shared?: number;
  rooms?: number;
  side?: string;
  buildingName?: string;
}

interface ApartmentFeaturesProps {
  features: Features;
  price?: number;
}

const ApartmentFeatures: React.FC<ApartmentFeaturesProps> = ({
  features,
  price,
}) => {
  const { t } = useTranslation();

  const getBathroomFeatureToShow = () => {
    if (features?.bathroom === true) {
      return { bathroom_private: 1 };
    }
    if (features?.bathroom === false) {
      return { bathroom_shared: 1 };
    }

    return {};
  };

  const formatFeatures = {
    ...features,
    ...getBathroomFeatureToShow(),
  };
  const formattedPrice = currencyFormatter(price || 0, "EUR", {
    style: "decimal",
    maximumFractionDigits: 2,
  });
  const hasPrice = typeof price === "number";
  return (
    <div className='apartment-features'>
      {ORDERED_FEATURE_KEYS.map(
        (feature) =>
          formatFeatures[feature] !== undefined && (
            <div className='feature' key={feature}>
              {ROOM_FEATURES_INFO[feature].iconName && (
                <Icon
                  size='small'
                  iconName={ROOM_FEATURES_INFO[feature].iconName}
                />
              )}
              <span>
                <Trans
                  i18nKey={ROOM_FEATURES_INFO[feature].label}
                  defaults={feature}
                  values={{
                    count: formatFeatures[feature],
                    ordinal: feature === "floor",
                  }}
                />
              </span>
            </div>
          ),
      )}
      {hasPrice && (
        <div className='price-container'>
          <span className='price'>
            <Trans
              i18nKey='card-rooms.feature.price'
              values={{
                count: formattedPrice,
              }}
            />
            <span className='per-month'>
              {t("card-rooms.feature.per-month")}
            </span>
          </span>
          <span className='price-container__taxes'>
            {t("card-rooms.feature.taxes")}
          </span>
        </div>
      )}
    </div>
  );
};

export default memo(ApartmentFeatures);
